import MoreVertIcon from "@mui/icons-material/MoreVert";
import NotInterestedIcon from "@mui/icons-material/NotInterested";
import SearchIcon from "@mui/icons-material/Search";
import {
    Autocomplete, Box, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Grid,
    IconButton,
    InputAdornment, Menu,
    MenuItem,
    Paper,
    Select,
    Switch,
    Table,
    TableBody,
    TableCell,
    TableHead,
    TableRow,
    TextField,
    Typography,
} from "@mui/material";
import LoadingButton from '@mui/lab/LoadingButton';
import SendIcon from '@mui/icons-material/Send';
import TickIcon from '@mui/icons-material/Done';
import CloseIcon from '@mui/icons-material/Close';
import Button from "@mui/material/Button";
import axios from "axios";
import * as React from "react";
import ReactCountryFlag from "react-country-flag";
import { NavLink } from "react-router-dom";
import { Avatar } from "../../components/Avatar";
import { CoatOfArms } from "../../components/CoatOfArms";
import { LeagueShield } from "../../components/League";
import { LoadingWrapper } from "../../components/LoadingWrapper";
import { Config } from "../../config/config";
import { CountryCodes } from "../../utils/countryCodes";
import { Helpers } from "../../utils/helpers";
import { PopupMessage } from "../../utils/message";
import { FILTER_BAN_STATUS, FILTER_LEAGUES, FILTER_PLATFORM, FILTER_STATUS } from "./constants";
import HealthAndSafetyIcon from '@mui/icons-material/HealthAndSafety';
import { title } from "process";

const CIconButton: any = IconButton;

interface PlayersStates {
    players: any[];
    loading: boolean;
    filter: PlayerFilterForm;
    form: {
        keyword: undefined | string;
        sort: string;
    }
    totalRecords: number;
    pushModalVisible: boolean;
    selectedPlayer: any | null;
    deviceModalVisible: boolean;
    anchorEl: any;
    rowsPerPage: number;
    page: number;
    menuVisible: boolean;
    showModal: boolean;
    loadingStates: any;
    responses: any;
    summaryData: any;
    time: string;
    ccu: number;
    pagination: Pagination;
    syncType: SyncType;
    auto: boolean;
    corruptedUsers: {
        showModal: boolean;
        infectedAmount: number;
        users: any[],
        offset: number;
        amount: number;
        userToFix: string;
        progress: any;
        progressInterval: any;
    },
    missingDeviceIdUsers:{
        showModal: boolean;
        infectedAamount: number;
        users: any[],
        offset: number;
        amount: number;
        userToFix: string;
        progress: any;
        progressInterval: any;
    },
    sendNotifyUserData: {
        showModal: boolean;
        title: string;
        content: string;
        sendByFcmList: boolean;
        fcmList: string;
        includeUsersMuted: boolean;
        progress: {totalUser: number, sendedUserCount: number, currentAction: string};
        progressInterval: any;
    }
}

export interface PlayerFilterForm {
    country: string | null;
    platform: string | null;
    status: string | null;
    ban_type: string | null;
    league: string | null;
    hq_level: number | null;
    locked: null | boolean;
    in_alliance: null | boolean;
}

interface Pagination {
    pageIndex: number;
    pageSize: number;
    totalPage: number;
}

export interface SearchFormProps {
    onFormSubmit(): void;
}

interface PlayersProps {
    activeUser: any;
    activeEnv: any;
    classes: any;
    form: any;
}

enum SyncType {
    USER_NAME = "USER_NAME",
    SAPPHIRE = "SAPPHIRE",
}

export class Players extends React.Component<PlayersProps, PlayersStates> {
    constructor(props: PlayersProps) {
        super(props);

        this.state = {
            filter: {
                country: null,
                platform: null,
                status: null,
                ban_type: null,
                league: null,
                hq_level: null,
                in_alliance: null,
                locked: null,
            },
            form: {
                keyword: undefined,
                sort: "joined_DESC",
            },
            players: [],
            loading: true,
            totalRecords: 0,
            pushModalVisible: false,
            selectedPlayer: null,
            deviceModalVisible: false,
            anchorEl: null,
            menuVisible: false,
            // Pagination
            page: 0,
            rowsPerPage: 10,
            showModal: false,
            loadingStates: new Map(),
            responses: new Map(),
            summaryData: [],
            time: this.getCurrentTime(),
            ccu: 0,
            pagination: {
                pageIndex: 0,
                pageSize: 10,
                totalPage: 1,
            },
            syncType: SyncType.USER_NAME,
            auto: false,
            corruptedUsers: {
                showModal: false,
                infectedAmount: 0,
                users: [],
                offset: 0,
                amount: 0,
                userToFix: "",
                progress: {},
                progressInterval: null,
            },
            missingDeviceIdUsers: {
                showModal: false,
                infectedAamount: 0,
                users: [],
                offset: 0,
                amount: 0,
                userToFix: "",
                progress: {},
                progressInterval: null,
            },
            sendNotifyUserData: {
                showModal: false,
                title: "System Notification!",
                content: "",
                sendByFcmList: false,
                fcmList: "",
                includeUsersMuted: false,
                progress: {totalUser: 0, sendedUserCount: 0, currentAction: ''},
                progressInterval: null,
            }
        };

        document.title = Helpers.documentTitle("Players");
    }

    getCurrentTime = () => {
        // Get current time
        const today = new Date();

        // Cover the case when day or month is less than 10
        const day = today.getDate() < 10 ? `0${today.getDate()}` : today.getDate();
        const month = (+today.getMonth() + 1) < 10 ? `0${(+today.getMonth() + 1)}` : (+today.getMonth() + 1);
        const year = today.getFullYear();

        // Cover the case when hour, minute, second is less than 10
        const hour = today.getHours() < 10 ? `0${today.getHours()}` : today.getHours();
        const minute = today.getMinutes() < 10 ? `0${today.getMinutes()}` : today.getMinutes();
        const second = today.getSeconds() < 10 ? `0${today.getSeconds()}` : today.getSeconds();

        // Format YYYY:MM:DD HH:mm:ss
        const date = `${year}-${month}-${day}`;

        // Format HH:mm:ss
        const time = `${hour}:${minute}:${second}`;

        // Format YYYY:MM:DD HH:mm:ss
        const dateTime = `${date} ${time}`;
        return dateTime;
    }

    componentDidMount() {
        this.getCcuByTime();
        this.fetchPlayers();
    }

    fetchPlayers = () => {
        const filteredFilters = Object.entries(this.state.filter).reduce((filters, [key, filter]) => {
            if (typeof filter === "object") {
                filters[key] = filter?.code || null;
                if(
                    key === "in_alliance"
                    || key === "locked"
                ) {
                    filters[key] = filter?.code;
                }
            } else {
                filters[key] = filter;
            }
            return filters;
        }, {});

        axios.post(`${Config.getInstance.apiUrl}/api/users/search`, {
            ...filteredFilters,
            ...this.state.form,
            ...this.state.pagination,
        }, {
            headers: {
                Authorization: Helpers.getSessionId(),
                env: this.props.activeEnv,
            },
        }).then(response => {
            const data = response.data.data;

            this.setState({
                loading: false,
                players: data || [],
                totalRecords: response.data.total,
                pagination: {
                    ...this.state.pagination,
                    totalPage: Math.ceil(response.data.total / this.state.pagination.pageSize),
                },
            });
        }).catch(_ => {
            PopupMessage.error("Something went wrong!");
        });
    }

    componentWillUnmount(): void {
        this.clearInterval();
    }

    clearFilters = () => {
        this.setState({
            filter: {
                country: null,
                platform: null,
                status: null,
                ban_type: null,
                league: null,
                hq_level: null,
                locked: null,
                in_alliance: null,
            },
            form: {
                keyword: undefined,
                sort: "joined_DESC",
            },
            loading: true
        }, () => {
            this.fetchPlayers()
        })
    }

    handleFilter(property: string, value: any) {
        const filterForm = { ...this.state.filter };
        filterForm[property] = value;

        if(property === "in_alliance") {
            console.log("in_alliance", value);
        }

        this.setState({ filter: filterForm });
    }

    handlePagination = (property: string, value: any) => {
        const { pagination } = this.state;
        pagination[property] = value;
        this.setState({ pagination });
        this.onPageChange();
    }

    handlePageChange = (event: any, step: number) => {
        const { pagination } = this.state;
        const { totalPage } = pagination;
        pagination.pageIndex += step;

        // Circlize page index
        if (pagination.pageIndex >= totalPage) {
            pagination.pageIndex = 0;
        } else if (pagination.pageIndex < 0) {
            pagination.pageIndex = totalPage - 1;
        }

        this.setState({ pagination });
        this.onPageChange();
    }

    handlePageChangeAuto = (event: any, step: number) => {
        const { pagination } = this.state;
        const { totalPage } = pagination;
        pagination.pageIndex += step;

        this.setState({ pagination });
        this.onPageChange();
    }

    removePlayer = (userId: string, deviceId: string) => {
        axios.post(`${Config.getInstance.apiUrl}/api/user/remove`, {
            userId,
            deviceId,
        }, {
            headers: {
                Authorization: Helpers.getSessionId(),
                env: this.props.activeEnv,
            },
        }).then(result => {
            this.setState((prevState) => ({
                players: prevState.players.filter(playerData => playerData.id !== userId),
            }));
        }).catch(() => {
            PopupMessage.error("Couldn't remove player");
        });
    };

    searchForm = () => this.setState({ loading: true }, () => {
        this.fetchPlayers();
    });

    getCcu = (time: string) => {
        this.setState({ loading: true });
        const localDate = new Date(time);
        const url = `${Config.getInstance.apiUrl}/api/users/ccu/${localDate.toISOString()}`;
        axios.post(url, {}, {
            headers: {
                Authorization: Helpers.getSessionId(),
                env: this.props.activeEnv,
            },
        }).then(response => {
            this.setState({
                loading: false,
                ccu: response.data.ccu,
            });
        }).catch(_ => {
            PopupMessage.error("Something went wrong!");
        });
    };

    getCcuNow = () => this.setState({ loading: true }, () => {
        const time = this.getCurrentTime();
        return this.getCcu(time);
    });

    //function check is time valid
    isValidDate = (dateString: string) => {
        const regEx = /^\d{4}-\d{2}-\d{2}\s\d{2}:\d{2}:\d{2}$/;
        if (!dateString.match(regEx)) return false;  // Invalid format
        return true;
    }

    getCcuByTime = () => {
        if (this.state.time.length < 19 || !this.isValidDate(this.state.time)) {
            alert("Please enter valid time format (YYYY-MM-DD HH:mm:ss)!");
            return;
        }
        this.getCcu(this.state.time)
    }


    openRowMenu = (event: any) => this.setState({ anchorEl: event.currentTarget }, () => this.setState({ menuVisible: true }));
    /**
     * For menu closing we have two functions to make animations smoother
     */
    closeRowMenu = () => this.setState({ menuVisible: false });
    clearMenuAnchor = () => this.setState({ anchorEl: null });

    getFileActions = () => {
        if (this.state.anchorEl) {
            const buttons: any[] = [];
            const userId = this.state.anchorEl.getAttribute("userid");
            const player = this.state.players.find(pl => pl.id === userId);

            if (player) {
                buttons.push(
                    <MenuItem key="edit-player-key">
                        <NavLink to={`/players/${player.id}`}
                            style={{ width: "100%", textDecoration: "none", color: "#000000" }}>Edit</NavLink>
                    </MenuItem>,
                );

                if (this.props.activeEnv !== "prod" && !player.is_online) {
                    buttons.push(
                        <MenuItem key="push-notification-key" style={{ color: "#e74c3c" }}
                            onClick={() => this.removePlayer(player.id, player.deviceid)}>
                            Delete
                        </MenuItem>,
                    );
                }

                return buttons;
            }
        }

        return null;
    };

    renderAllianceInfo(item: any) {
        if (!item.squad) {
            return null;
        }

        return <div style={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
            <CoatOfArms emblem={item.squad.flag} size="small" />
            <span style={{ marginLeft: 5 }}>{item.squad.name}</span>
        </div>
    }

    formatTableBody = (items: any[]) => {
        if (this.state.loading) {
            return <TableRow key="loading-row">
                <TableCell colSpan={11}>
                    {Helpers.renderSkeletonRows(5, 50)}
                </TableCell>
            </TableRow>
        }

        return items.map(item => (
            <TableRow
                key={item.id}
                hover={true}
            >
                <TableCell style={{ width: 92 }}>
                    {Avatar(item)}
                </TableCell>
                <TableCell style={{ width: 152 }}>
                    <NavLink to={`/players/${item.id}`}>
                        {item.name}
                    </NavLink>
                </TableCell>
                <TableCell>
                    {item.id}
                </TableCell>
                <TableCell align="center" style={{ width: 160 }}>
                    {this.renderAllianceInfo(item)}
                </TableCell>
                <TableCell align="center" style={{ width: 90 }}>
                    {item.tag}
                </TableCell>
                <TableCell align="center" style={{ width: 50 }}>
                    {LeagueShield({
                        rank: item.rank,
                        showRank: true,
                        showLeagueName: true,
                    })}
                </TableCell>
                <TableCell align="center" style={{ width: 50 }}>
                    {item.headquarter_level}
                </TableCell>
                <TableCell align="center" style={{ width: 50 }}>
                    {item.vip_system.level}
                </TableCell>
                <TableCell align="center" style={{ width: 50 }}>{item.rubies}</TableCell>
                <TableCell align="center" style={{ width: 50 }}>
                    <ReactCountryFlag countryCode={item.country} svg={true} />
                    <span style={{ marginLeft: 5, fontSize: 12 }}>{item.country}</span>
                </TableCell>
                <TableCell>
                    <CIconButton
                        size="small"
                        userid={item.id}
                        onClick={this.openRowMenu}
                    >
                        <MoreVertIcon />
                    </CIconButton>
                </TableCell>
            </TableRow>
        ));
    };

    pageContent = (items) => {
        if (!this.state.loading && items.length === 0) {
            return <div className="no-items-placeholder">
                <NotInterestedIcon />
                <h3>No players found</h3>
            </div>;
        }

        return <React.Fragment>
            <Table className="min-table-size">
                <TableRow>
                    <TableCell>
                        <Button
                            disableElevation
                            variant="contained"
                            color="primary"
                            style={{ width: "90%" }}
                            onClick={() => this.onShowSendNotificationToAllUserModal()}
                        >
                            Send notification to all users
                        </Button>
                    </TableCell>
                    <TableCell>
                        <TextField
                            placeholder="YYYY-MM-DD HH:mm:ss"
                            style={{ width: "90%" }}
                            value={this.state.time}
                            onChange={(e) => this.timeHandleChange(e)}
                            onKeyDown={(e) => e.key === "Enter" && this.getCcuByTime()}
                            InputProps={{
                                startAdornment: (
                                    <InputAdornment position="start">
                                        <SearchIcon />
                                    </InputAdornment>
                                ),
                            }}
                            variant="outlined"
                            size="small"
                        />
                    </TableCell>

                    <TableCell>
                        <Button
                            disableElevation
                            variant="contained"
                            color="primary"
                            style={{ width: "110%" }}
                            onClick={() => this.getCcuByTime()}
                        >
                            CCU by Time
                        </Button>
                    </TableCell>

                    <TableCell>
                        <Button
                            disableElevation
                            variant="contained"
                            color="primary"
                            style={{ width: "100%" }}
                            onClick={() => this.getCcuNow()}
                        >
                            CCU Now
                        </Button>
                    </TableCell>

                    <TableCell>
                        <label
                            color="secondary"
                            style={{ display: "block", width: "100%", fontSize: 40, textAlign: "center", color: "#03fcf4" }}

                        >
                            ccu: {this.state.ccu}
                        </label>
                    </TableCell>
                </TableRow>
            </Table>

            <Table className="min-table-size">
                <TableHead>
                    <TableRow>
                        <TableCell style={{ width: 92 }}>Avatar</TableCell>
                        <TableCell style={{ width: 152 }}>Username</TableCell>
                        <TableCell>User id</TableCell>
                        <TableCell style={{ width: 160 }} align="center">Alliance</TableCell>
                        <TableCell style={{ width: 90 }} align="center">Tag</TableCell>
                        <TableCell style={{ width: 50 }} align="center">League</TableCell>
                        <TableCell style={{ width: 50 }} align="center">Core</TableCell>
                        <TableCell style={{ width: 50 }} align="center">VIP</TableCell>
                        <TableCell style={{ width: 50 }} align="center">Gold</TableCell>
                        <TableCell style={{ width: 50 }} align="center">Country</TableCell>
                        <TableCell style={{ width: 40 }}></TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {this.formatTableBody(items)}
                </TableBody>
            </Table>
            <Menu
                id="long-menu"
                anchorEl={this.state.anchorEl}
                open={this.state.menuVisible}
                onClose={this.closeRowMenu}
                TransitionProps={{
                    onExited: this.clearMenuAnchor
                }}
            >
                {this.getFileActions()}
            </Menu>
        </React.Fragment>;
    }

    searchInput(e: any, key: string) {
        const tempForm = { ...this.state.form };
        tempForm[key] = e.target.value;

        this.setState({ form: tempForm });
    }

    timeHandleChange(e: any) {
        this.setState({ time: e.target.value });
    }

    onShowModal = () => {
        this.setState({ showModal: true });
    }

    onShowCorruptedUsersModal = () => {
        const { corruptedUsers } = this.state;
        corruptedUsers.showModal = true;
        this.setState({ corruptedUsers });

        this.fetchCorruptedUsers();
    }

    onHideCorruptedUsersModal = () => {
        const { corruptedUsers } = this.state;
        corruptedUsers.showModal = false;
        this.setState({ corruptedUsers });
    }

    fetchCorruptedUsers = async () => {
        const url = `${Config.getInstance.apiUrl}/api/users/corrupted_amount`;
        const headers = {
            Authorization: Helpers.getSessionId(),
            env: this.props.activeEnv,
        };

        const response = await axios.get(url, { headers });
        const data = response.data;

        if (data.success) {
            const { corruptedUsers } = this.state;
            corruptedUsers.infectedAmount = data.amount;
            corruptedUsers.users = data.users;

            this.setState({ corruptedUsers });
        } else {
            PopupMessage.error("Fetch corrupted users failed");
        }
    }
    
    onHideModal = () => {
        // Reset loading states
        const { loadingStates } = this.state;
        loadingStates.clear();

        // Reset responses
        const { responses } = this.state;
        responses.clear();

        // Reset summary data
        const { summaryData } = this.state;
        summaryData.length = 0;

        // Set state
        this.setState({ showModal: false, loadingStates, responses, summaryData });
    }

    onSyncAll = async () => {
        const { players, pagination } = this.state;

        // We will call on SyncPlayer and wait for response to call the next one
        // Await in loop
        for (let i = 0; i < players.length; i++) {
            const player = players[i];
            await this.onSyncPlayer(player.id, player.name, player.avatar);
        }

        if (this.state.auto) {
            // Check if current page is the last page
            this.handlePageChangeAuto("pageIndex", 1);

            const { pageIndex, totalPage } = pagination;
            if (pageIndex >= totalPage) {
                this.handlePageChange("pageIndex", 1);
                return;
            }
            this.onSyncAll();
        }
    }

    onSyncAllSapphire = async () => {
        const { players, pagination } = this.state;

        for (let i = 0; i < players.length; i++) {
            const player = players[i];
            await this.onSyncSapphire(player.id);
        }

        if (this.state.auto) {
            // Check if current page is the last page
            this.handlePageChangeAuto("pageIndex", 1);

            const { pageIndex, totalPage } = pagination;
            if (pageIndex >= totalPage) {
                this.handlePageChange("pageIndex", 1);
                return;
            }
            this.onSyncAllSapphire();
        }
    }

    // onSyncAllSystem = async () => {
    //     const url = `${Config.getInstance.apiUrl}/api/users/sync-all-web-data`;
    //     const response = await axios.post(url, {}, {
    //         headers: {
    //             Authorization: Helpers.getSessionId(),
    //             env: this.props.activeEnv,
    //         },
    //     });
    // }

    onSyncPlayer = async (userId: string, name: string, avatar: string) => {
        const { loadingStates, syncType, summaryData } = this.state;

        if (syncType !== SyncType.USER_NAME) {
            // Reset summary data
            summaryData.length = 0;
        }

        loadingStates.set(userId, true);
        this.setState({ loadingStates });

        // Call API
        const url = `${Config.getInstance.apiUrl}/api/users/sync-web-data/${userId}`;

        // response = {data: {success: true, message: "Something went wrong"}}
        const response = await axios.post(url, {},
            {
                headers: {
                    Authorization: Helpers.getSessionId(),
                    env: this.props.activeEnv,
                },
            });

        // console.log('response data', response.data )
        // Update loading state

        loadingStates.set(userId, false);
        this.setState({ loadingStates });

        // Load Tick Icon
        let icon = <TickIcon style={{ color: "green" }} />;
        if (!response.data.success) {
            icon = <CloseIcon style={{ color: "red" }} />;
        }

        // Update response
        const { responses } = this.state;

        // Update response to <div> <icon> <message> </div>
        const message = response.data.message || "Something went wrong";
        const responseElement = <div>{icon} {message}</div>;
        responses.set(userId, responseElement);
        this.setState({ responses, summaryData, syncType: SyncType.USER_NAME });

        // Update summary data
        this.updateSummaryData(userId, response.data.success);
    }

    onSyncSapphire = async (userId: string) => {
        const { loadingStates, syncType, summaryData } = this.state;
        if (syncType === SyncType.USER_NAME) {
            // Reset summary data
            summaryData.length = 0;
        }
        loadingStates.set(userId, true);
        this.setState({ loadingStates });

        // Call API
        const url = `${Config.getInstance.apiUrl}/api/users/sync-web-sapphire/${userId}`;

        // response = {data: {success: true, message: "Something went wrong"}}
        const response = await axios.post(url, {},
            {
                headers: {
                    Authorization: Helpers.getSessionId(),
                    env: this.props.activeEnv,
                },
            });

        // console.log('response data', response.data )
        // Update loading state

        loadingStates.set(userId, false);
        this.setState({ loadingStates });

        // Load Tick Icon
        let icon = <TickIcon style={{ color: "green" }} />;
        if (!response.data.success) {
            icon = <CloseIcon style={{ color: "red" }} />;
        }

        // Update response
        const { responses } = this.state;

        // Update response to <div> <icon> <message> </div>
        const message = response.data.message || "Something went wrong";
        const responseElement = <div>{icon} {message}</div>;
        responses.set(userId, responseElement);
        this.setState({ responses, summaryData, syncType: SyncType.SAPPHIRE });

        // Update summary data
        this.updateSummaryData(userId, response.data.success);
    }

    updateSummaryData = (userId: string, success: boolean) => {
        const { summaryData } = this.state;
        const index = summaryData.findIndex(item => item.userId === userId);
        if (index === -1) {
            summaryData.push({
                userId,
                success,
            });
        } else {
            summaryData[index].success = success;
        }

        this.setState({ summaryData });

        // // If all players are synced, show summary
        // if (summaryData.length === this.state.players.length) {
        //     this.showSummary();
        // }

        // If all players are synced, show PopupMessage
        if (summaryData.length === this.state.players.length) {
            PopupMessage.success("Synced all players");
        }
    }

    showSummary = () => {
        const { summaryData, players } = this.state;

        // Count success
        const successCount = summaryData.filter(item => item.success).length;

        // Count failed
        const failedCount = summaryData.filter(item => !item.success).length;

        // Show summary
        const message = `Total: ${summaryData.length}. Synced ${successCount} players. Failed ${failedCount} players.`;
        PopupMessage.success(message);
    }

    getPageArray = () => {
        const { pagination } = this.state;
        const { totalPage } = pagination;
        const pageArray: number[] = [];
        for (let i = 0; i < totalPage; i++) {
            pageArray.push(i);
        }

        return pageArray;
    }

    onChangeCorruptedUsersValue = (event: any, key: string) => {
        const { corruptedUsers } = this.state;
        corruptedUsers[key] = event.target.value;
        this.setState({ corruptedUsers });
    }

    copyToClipboard = (str: string) => {
        navigator.clipboard.writeText(str);

        PopupMessage.success("Copied to clipboard");
    }

    onGetListCorruptedUsers = () => {
        const { corruptedUsers } = this.state;
        const offset = corruptedUsers.offset;
        const amount = corruptedUsers.amount;
        const users = corruptedUsers.users.slice(offset, offset + amount);

        const result = users.map((user: any) => user.id).join(",");

        this.copyToClipboard(result);
    }

    onFixCorruptedUsers = async () => {
        try {
            const { corruptedUsers } = this.state;
            const userIds = corruptedUsers.userToFix;

            const url = `${Config.getInstance.apiUrl}/api/users/fix_corrupted`;
            const headers = {
                Authorization: Helpers.getSessionId(),
            };

            this.startInterval();

            const response = await axios.post(url, { userIds }, { headers });

            // clear interval
            this.clearInterval();

            this.fetchCorruptedUsers();

            if (response.data.success) {
                PopupMessage.success("Fixed corrupted users successfully");
            } else {
                PopupMessage.error("Fix corrupted users failed");
            }

            this.setState({ corruptedUsers });
        } catch (e) {
            console.log('onFixCorruptedUsers', e);
        }
    }

    startInterval = () => {
        const { corruptedUsers } = this.state;
        const progressInterval = setInterval(() => {
            this.getProgress();
        }, 1000);

        corruptedUsers.progressInterval = progressInterval;
        this.setState({ corruptedUsers });
    }

    clearInterval = () => {
        const { corruptedUsers } = this.state;
        if (corruptedUsers.progressInterval) {
            clearInterval(corruptedUsers.progressInterval);
        }
    }

    getProgress = async () => {
        const { corruptedUsers } = this.state;
        const url = `${Config.getInstance.apiUrl}/api/users/fix_corrupted_progress`;
        const headers = {
            Authorization: Helpers.getSessionId(),
        };

        const response = await axios.get(url, { headers });

        if (response.data.success) {
            const progress = response.data.progress;
            corruptedUsers.progress = progress;

            this.setState({ corruptedUsers });
        }
    }

    onEventSourceGetMessage = (event: any) => {
        // Data is string
        const data = JSON.parse(event.data);
        console.log("event source data", data);
    }

    renderCorruptedUsersModal = () => {

        const styles = {
            h5: { display: "flex", alignItems: "center", justifyContent: "center", marginBottom: '10px' },
            h6: { display: "flex", alignItems: "center", marginBottom: '10px' },
        }

        return <Dialog
            open={this.state.corruptedUsers.showModal}
            onClose={this.onHideCorruptedUsersModal}
            fullWidth={true}
            maxWidth="lg"
        >
            <DialogTitle>
                Number of corrupted users: {this.state.corruptedUsers.infectedAmount}
            </DialogTitle>
            <DialogContent dividers>
                <Grid container sm={12}>
                    <Grid item container sm={6} rowSpacing={2} style={styles.h5}>
                        <Grid sm={8}>
                            <Typography variant="h5">Get Data</Typography>
                        </Grid>
                        <Grid container style={styles.h6}>
                            <Grid item sm={2}>
                                <Typography variant="h6">Offset:</Typography>
                            </Grid>
                            <Grid item sm={6}>
                                <TextField
                                    inputProps={{ type: "number" }}
                                    value={this.state.corruptedUsers.offset}
                                    onChange={(e) => this.onChangeCorruptedUsersValue(e, "offset")}
                                />
                            </Grid>
                        </Grid>

                        <Grid container style={styles.h6}>
                            <Grid item sm={2}>
                                <Typography variant="h6">Amount:</Typography>
                            </Grid>
                            <Grid item sm={6}>
                                <TextField
                                    inputProps={{ type: "number" }}
                                    value={this.state.corruptedUsers.amount}
                                    onChange={(e) => this.onChangeCorruptedUsersValue(e, "amount")}
                                />
                            </Grid>
                        </Grid>

                        <Grid container style={styles.h6}>
                            <Button
                                disableElevation
                                variant="contained"
                                color="primary"
                                onClick={this.onGetListCorruptedUsers}
                            >
                                Copy to clipboard
                            </Button>
                        </Grid>
                    </Grid>

                    <Grid item container sm={6} rowSpacing={2} style={styles.h5}>
                        <Grid item sm={12}>
                            <Typography variant="h5">Fix User Data</Typography>
                        </Grid>

                        <Grid item sm={12}>
                            <TextField
                                placeholder="Enter user ids separated by comma, ex: 1,2,3"
                                value={this.state.corruptedUsers.userToFix}
                                onChange={(e) => this.onChangeCorruptedUsersValue(e, "userToFix")}
                                multiline
                                rows={5}
                                fullWidth
                            />
                        </Grid>
                        <Grid item sm={12}>
                            <Button
                                disableElevation
                                variant="contained"
                                color="primary"
                                onClick={this.onFixCorruptedUsers}
                                style={{ float: "right" }}
                            >
                                <HealthAndSafetyIcon />
                                Fix them!
                            </Button>
                        </Grid>
                    </Grid>
                </Grid>
                <Grid sm={12}>
                    <Typography variant="h6">Progress</Typography>
                    <div>
                        {this.renderProress()}
                    </div>
                </Grid>
            </DialogContent>
        </Dialog>
    }

    

    renderProress = () => {
        const { corruptedUsers } = this.state;
        const progress = corruptedUsers.progress;

        // If progress is empty, return empty string
        if (Object.keys(progress).length === 0) {
            return "";
        }

        /*
        {
            totalUser: 0,
            currentUser: 0,
            totalSession: 0,
            currentSession: 0,
            currentAction: "",
        }
        */

        const str = `User (${progress.currentUser}/${progress.totalUser})
        Session (${progress.currentSession}/${progress.totalSession})
        Action: ${progress.currentAction}`;

        return str;
    }

    renderPagination = () => {
        // Render pagination with format < 1 2 3 4 5 > with current page is big
        const { pagination } = this.state;
        const { pageIndex, totalPage } = pagination;

        // Full width pagination, middle align
        const style = {
            width: "100%",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
        }

        // Active style: bigger font
        const activeStyle = {
            color: "#fff",
            borderColor: "#007bff",
            fontSize: "1.6rem",
            margin: "0 5px",
        }

        // Space between each page
        const spaceStyle = {
            margin: "0 5px",
        }

        const SHOWN_PAGES = 5;

        const shownArray: number[] = [];

        // Always show 5 pages, 2 pages before and 2 pages after current page with circlize
        for (let i = 0; i < Math.min(SHOWN_PAGES, totalPage); i++) {
            let index = pageIndex - 2 + i;
            if (index < 0) {
                index += totalPage;
            } else if (index >= totalPage) {
                index -= totalPage;
            }
            shownArray.push(index);
        }

        const result = <div style={style}>
            <a style={spaceStyle} href="#" onClick={() => this.handlePageChange("pageIndex", -1)}>&laquo;</a>
            {
                // Always show 5 pages, 2 pages before and 2 pages after current page with circlize
                shownArray.map((item, index) => {
                    return <a
                        style={item === pageIndex ? activeStyle : spaceStyle}
                        href="#"
                        onClick={() => this.handlePagination("pageIndex", item)}
                    >
                        {item + 1}
                    </a>
                })
            }
            <a style={spaceStyle} href="#" onClick={() => this.handlePageChange("pageIndex", 1)}>&raquo;</a>
        </div>

        return result;
    }

    onPageChange = () => {
        // Request new data
        this.fetchPlayers();
    }

    changeAutoFlag = async (event) => {
        const flag = event.target.checked;
        this.setState({ auto: flag });
    }

    renderSummary = () => {
        const { summaryData, players, auto } = this.state;

        // Count success
        const successCount = summaryData.filter(item => item.success).length;

        // Count failed
        const failedCount = summaryData.filter(item => !item.success).length;

        // Show summary with icons
        const successIcon = <TickIcon style={{ color: "green" }} />;
        const failedIcon = <CloseIcon style={{ color: "red" }} />;

        // message will be <div> <successIcon> <successMessage>, <failedIcon> <failedMessage> </div>
        const message = <div>
            Total: {auto ? summaryData.length : players.length} Players. {successIcon} Synced {successCount} players. {failedIcon} Failed {failedCount} players.
        </div>;
        return <div style={{ marginRight: 20 }}>{message}</div>;
    }

    renderSyncList = () => {
        const { loadingStates } = this.state;

        // Load sapphire icon from resouces/asset/images/icon/Sapphire.png
        const sapphireIcon = <img src={require("../../../assets/images/icons/Sapphire.png").default} style={{ width: 30, height: 30 }} />;

        // <img src={require("../../../assets/images/icons/Sapphire.png").default} />

        return <React.Fragment>
            {
                // Render a title of sync list
                <div style={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
                    <h2 style={{ marginRight: 20 }}>Sync Data To Web</h2>
                </div>
            }
            <Table className="min-table-size">
                <TableHead>
                    <TableCell style={{ width: "10%" }}>Avatar</TableCell>
                    <TableCell style={{ width: "10%" }}>Username</TableCell>
                    <TableCell style={{ width: "30%" }}>User id</TableCell>
                    <TableCell style={{ width: "15%" }}>
                        <Button disableElevation onClick={this.onSyncAll} color="primary" variant="contained">
                            Sync All
                        </Button>
                    </TableCell>
                    <TableCell style={{ width: "15%" }}>
                        <Button disableElevation onClick={this.onSyncAllSapphire} color="primary" variant="contained">
                            Sync All {sapphireIcon}
                        </Button>
                    </TableCell>
                    <TableCell> Response </TableCell>
                    {
                        // Toggle button auto sync
                        <TableCell style={{ width: "10%" }}>
                            <Switch
                                checked={this.state.auto}
                                onChange={this.changeAutoFlag.bind(this)}
                                name="maintenanceFlag"
                                inputProps={{ 'aria-label': 'controlled' }}
                            />
                        </TableCell>
                    }
                </TableHead>
                <TableBody>
                    {
                        this.state.players.map((player, index) => {
                            return <TableRow
                                key={player.id}
                                hover={true}
                            >
                                <TableCell style={{ width: "10%" }}>
                                    {Avatar(player)}
                                </TableCell>
                                <TableCell style={{ width: "10%" }}>
                                    <NavLink to={`/players/${player.id}`}>
                                        {player.name}
                                    </NavLink>
                                </TableCell>
                                <TableCell style={{ width: "30%" }}>
                                    {player.id}
                                </TableCell>
                                <TableCell style={{ width: "10%" }}>
                                    <LoadingButton
                                        onClick={() => this.onSyncPlayer(player.id, player.name, player.avatar)}
                                        loading={loadingStates.get(player.id) || false}
                                        loadingPosition="start"
                                        startIcon={<SendIcon />}
                                        variant="contained"
                                    >
                                        <span>Info</span>
                                    </LoadingButton>
                                </TableCell>

                                <TableCell style={{ width: "10%" }}>
                                    <LoadingButton
                                        onClick={() => this.onSyncSapphire(player.id)}
                                        loading={loadingStates.get(player.id) || false}
                                        loadingPosition="start"
                                        startIcon={<SendIcon />}
                                        variant="contained"
                                    >
                                        <span>Sapphire</span>
                                    </LoadingButton>
                                </TableCell>

                                <TableCell>
                                    {this.state.responses.get(player.id) || null}
                                </TableCell>

                            </TableRow>
                        })
                    }
                </TableBody>
            </Table>

        </React.Fragment>
    }

    renderSyncTable = () => {
        return <Dialog
            open={this.state.showModal}
            onClose={this.onHideModal}
            fullWidth={true}
            maxWidth="lg"
        >
            <DialogContent dividers>
                {
                    this.renderSyncList()
                }

            </DialogContent>

            <DialogActions>
                {this.renderSummary()}
                {/* <Button disableElevation onClick={this.onHideModal} variant="contained">
                    Cancel
                </Button>
                <Button disableElevation onClick={this.onSyncAll} color="primary" variant="contained">
                    Sync All
                </Button> */}
                {/* <Button disableElevation onClick={this.onSyncAllSystem} color="primary" variant="contained">
                Sync All System
            </Button> */}
            </DialogActions>
        </Dialog>
    }

    render() {
        return <React.Fragment>
            <Paper elevation={0} className="page-filters">
                <Grid container spacing={2}>
                    <Grid item sm={12}>
                        <Button
                            disableElevation
                            variant="contained"
                            color="primary"
                            style={{ width: "100%" }}
                            onClick={() => this.onShowModal()}
                        >
                            Sync Web Data
                        </Button>

                    </Grid>

                    <Grid item sm={12}>
                        <Button
                            disableElevation
                            variant="contained"
                            color="primary"
                            style={{ width: "100%" }}
                            onClick={() => this.onShowCorruptedUsersModal()}
                        >
                            Corrupted Users
                        </Button>

                    </Grid>
                    <Grid item sm={12}>
                        <Button
                            disableElevation
                            variant="contained"
                            color="primary"
                            style={{ width: "100%" }}
                            onClick={() => this.onShowMissingDeviceIdUsersModal()}
                        >
                            Missing DeviceIds Users
                        </Button>

                    </Grid>
                    <Grid item sm={12}>
                        <TextField
                            placeholder="Search…"
                            style={{ width: "100%" }}
                            onKeyUp={(e) => this.searchInput(e, "keyword")}
                            onKeyDown={(e) => e.key === "Enter" && this.searchForm()}
                            InputProps={{
                                startAdornment: (
                                    <InputAdornment position="start">
                                        <SearchIcon />
                                    </InputAdornment>
                                ),
                            }}
                            variant="outlined"
                            size="small"
                        />
                    </Grid>

                    <Grid item sm={12}>
                        <Typography variant="h6">
                            Filters
                        </Typography>
                    </Grid>

                    <Grid item xs={12}>
                        <Autocomplete
                            onChange={(_, newValue) => this.handleFilter("country", newValue)}
                            value={this.state.filter.country || ""}
                            options={CountryCodes.sort((a, b) => -b.name.localeCompare(a.name))}
                            getOptionLabel={option => option?.name || ""}
                            disableClearable={true}
                            renderOption={(props, item) => (
                                <Box component="li" {...props}>
                                    <ReactCountryFlag countryCode={item.code} svg={true} />
                                    <span style={{ marginLeft: 7, fontSize: 15 }}>{item.name}</span>
                                </Box>
                            )}
                            renderInput={(params) =>
                                <TextField {...params}
                                    label="Country"
                                    variant="outlined"
                                    size="small"
                                />}
                        />
                    </Grid>
                    <Grid item xs={12}>
                        <Autocomplete
                            onChange={(_, newValue) => this.handleFilter("platform", newValue)}
                            value={this.state.filter.platform || ""}
                            options={FILTER_PLATFORM.sort((a, b) => -b.code.localeCompare(a.code))}
                            getOptionLabel={option => option?.label || ""}
                            disableClearable={true}
                            renderInput={(params) =>
                                <TextField
                                    {...params}
                                    label="Platform"
                                    variant="outlined"
                                    size="small"
                                />
                            }
                        />
                    </Grid>
                    <Grid item xs={12}>
                        <Autocomplete
                            onChange={(_, newValue) => this.handleFilter("status", newValue)}
                            value={this.state.filter.status || ""}
                            options={FILTER_STATUS.sort((a, b) => -b.code.localeCompare(a.code))}
                            getOptionLabel={option => option?.label || ""}
                            disableClearable={true}
                            renderInput={(params) =>
                                <TextField
                                    {...params}
                                    label="Status"
                                    variant="outlined"
                                    size="small"
                                />
                            }
                        />
                    </Grid>
                    <Grid item xs={12}>
                        <Autocomplete
                            onChange={(_, newValue) => this.handleFilter("ban_type", newValue)}
                            value={this.state.filter.ban_type || ""}
                            options={FILTER_BAN_STATUS.sort((a, b) => -b.code.localeCompare(a.code))}
                            getOptionLabel={option => option?.label || ""}
                            disableClearable={true}
                            renderInput={(params) =>
                                <TextField
                                    {...params}
                                    label="Ban status"
                                    variant="outlined"
                                    size="small"
                                />
                            }
                        />
                    </Grid>
                    <Grid item xs={12}>
                        <Autocomplete
                            onChange={(_, newValue) => this.handleFilter("locked", newValue)}
                            value={this.state.filter.locked || ""}
                            options={[{ code: true, label: "True" }, { code: false, label: "False" }] as any[]}
                            getOptionLabel={option => option?.label || ""}
                            disableClearable={true}
                            renderInput={(params) =>
                                <TextField
                                    {...params}
                                    label="Locked"
                                    variant="outlined"
                                    size="small"
                                />
                            }
                        />
                    </Grid>
                    <Grid item xs={12}>
                        <Autocomplete
                            onChange={(_, newValue) => this.handleFilter("in_alliance", newValue)}
                            value={this.state.filter.in_alliance || ""}
                            options={[{ code: true, label: "True" }, { code: false, label: "False" }] as any[]}
                            getOptionLabel={option => option?.label || ""}
                            disableClearable={true}
                            renderInput={(params) =>
                                <TextField
                                    {...params}
                                    label="In alliance"
                                    variant="outlined"
                                    size="small"
                                />
                            }
                        />
                    </Grid>
                    <Grid item xs={12}>
                        <Autocomplete
                            onChange={(_, newValue) => this.handleFilter("league", newValue)}
                            value={this.state.filter.league || ""}
                            options={FILTER_LEAGUES}
                            getOptionLabel={option => option?.label || ""}
                            disableClearable={true}
                            renderInput={(params) =>
                                <TextField
                                    {...params}
                                    label="League"
                                    variant="outlined"
                                    size="small"
                                />
                            }
                        />
                    </Grid>
                    <Grid item xs={12}>
                        <TextField
                            type={"number"}
                            variant="outlined"
                            size={"small"}
                            label={"HQ Level"}
                            style={{ width: "100%" }}
                            onChange={(e) => this.handleFilter("hq_level", +e.target.value)}
                            value={this.state.filter.hq_level || ""}
                        />
                    </Grid>

                    <Grid item sm={5}>
                        <Typography variant="h6">
                            Sort
                        </Typography>
                    </Grid>

                    <Grid item sm={6}>
                        <Select
                            value={this.state.form.sort}
                            onChange={(e) => this.searchInput(e, "sort")}
                            size="small"
                            style={{ width: "120%" }}
                        >
                            <MenuItem value="joined_ASC">Created ASC</MenuItem>
                            <MenuItem value="joined_DESC">Created DESC</MenuItem>
                            <MenuItem value="rank_ASC">Rank ASC</MenuItem>
                            <MenuItem value="rank_DESC">Rank DESC</MenuItem>
                        </Select>
                    </Grid>

                    <Grid item sm={5}>
                        <Typography variant="h6">
                            Pagination
                        </Typography>
                    </Grid>

                    <Grid item xs={6}>
                        <TextField
                            type={"number"}
                            variant="outlined"
                            size={"small"}
                            label={"Page size"}
                            style={{ width: "120%" }}
                            onChange={(e) => this.handlePagination("pageSize", +e.target.value)}
                            value={this.state.pagination.pageSize}
                        />
                    </Grid>
                    <Grid item xs={12}>
                        {this.renderPagination()}
                    </Grid>

                    {/* <Grid item xs={6}>
                        <TextField
                            label={"Page index"}
                            select
                            value={this.state.pagination.pageIndex}
                            onChange={(e) => this.handlePagination("pageIndex", +e.target.value)}
                            size="small"
                            style={{width: "100%"}}
                        >
                            {this.getPageArray().map((item, index) => {
                                return <MenuItem value={index}>{index}</MenuItem>
                            })}

                        </TextField>
                    </Grid> */}

                    <Grid item xs={6}>
                        <Button
                            disableElevation
                            variant="contained"
                            color="primary"
                            style={{ width: "100%" }}
                            onClick={() => this.searchForm()}
                        >
                            Search
                        </Button>
                    </Grid>

                    <Grid item xs={6}>
                        <Button
                            disableElevation
                            variant="contained"
                            color="secondary"
                            style={{ width: "100%" }}
                            onClick={this.clearFilters}
                        >
                            Clear
                        </Button>
                    </Grid>
                </Grid>
            </Paper>

            {this.renderSyncTable()}
            {this.renderCorruptedUsersModal()}
            {this.renderMissingDeviceIdUsersModal()}
            {this.renderSendNotifyUsesModal()}
            <div className="contentPadding-withFilters" style={{ marginBottom: 20 }}>
                <Paper className="root" elevation={0}>
                    {this.pageContent(this.state.players)}
                </Paper>
            </div>
        </React.Fragment>
    }

    //#region Missing device id users

    fetchMDIDUsers = async () => {
        const url = `${Config.getInstance.apiUrl}/api/users/get-missing-device-users`;
        const headers = {
            Authorization: Helpers.getSessionId(),
            env: this.props.activeEnv,
        };

        const response = await axios.get(url, { headers });
        const data = response.data;

        if (data.success) {
            const { missingDeviceIdUsers } = this.state;
            missingDeviceIdUsers.infectedAamount = data.amount;
            missingDeviceIdUsers.users = data.users;

            this.setState({ missingDeviceIdUsers });
        } else {
            PopupMessage.error("Fetch corrupted users failed");
        }
    }

    fetchSendNotifyUserData = async () => {
        try {
            const url = `${Config.getInstance.apiUrl}/api/users/get_user_fcm_count`;
            const headers = {
                Authorization: Helpers.getSessionId(),
                env: this.props.activeEnv,
            };

            const response = await axios.get(url, { headers });
            const data = response.data;

            console.log("fetchSendNotifyUserData", data);

            if (data.success) {
                const { sendNotifyUserData } = this.state;
                sendNotifyUserData.progress.totalUser = data.totalUser;
                
                this.setState({ sendNotifyUserData });
            } else {
                PopupMessage.error("fetchSendNotifyUserData: Fetch corrupted users failed");
            }
        }
        catch (e) {
            console.log('fetchSendNotifyUserData', e);
            PopupMessage.error(`fetchSendNotifyUserData ${e.message}`);
        }
    }

    onShowMissingDeviceIdUsersModal = ()=>{
        const {missingDeviceIdUsers} = this.state;
        missingDeviceIdUsers.showModal = true;
        this.setState({missingDeviceIdUsers});
        
        this.fetchMDIDUsers();
    }

    onHideMissingDeviceIdUsersModal = ()=>{
        const {missingDeviceIdUsers} = this.state;
        missingDeviceIdUsers.showModal = false;
        this.setState({missingDeviceIdUsers});
    }

    onChangeMDIDUsersValue = (event: any, key: string) => {
        console.log("onChangeMDIDUsersValue", event.target.value);
        const { missingDeviceIdUsers } = this.state;
        missingDeviceIdUsers[key] = event.target.value;
        this.setState({ missingDeviceIdUsers });
    }

    onGetListMDIDUsers = () => {
        const { missingDeviceIdUsers } = this.state;
        const offset = missingDeviceIdUsers.offset;
        const amount = missingDeviceIdUsers.amount;
        const users = missingDeviceIdUsers.users.slice(offset, offset + amount);

        const result = users.map((user: any) => user.user_id).join(",");

        this.copyToClipboard(result);
    }

    onFixMDIDUsers = async () => {
        try {
            const { missingDeviceIdUsers } = this.state;
            const userIds = missingDeviceIdUsers.userToFix;
            console.log(userIds);           
            const url = `${Config.getInstance.apiUrl}/api/users/fix-wrong-deviceid-user`;
            const headers = {
                Authorization: Helpers.getSessionId(),
            };

            this.startMDIDInterval();

            const response = await axios.post(url, { userIds }, { headers });

            // cleat interval
            this.clearMDIDInterval();

            await this.fetchMDIDUsers();

            if (response.data.success) {
                PopupMessage.success("Fixed corrupted users successfully");
            } else {
                PopupMessage.error("Fix corrupted users failed");
            }

            this.setState({ missingDeviceIdUsers });
        } catch (e) {
            console.log('onFixCorruptedUsers', e);
        }
    }

    startMDIDInterval = () => {
        const { missingDeviceIdUsers } = this.state;
        const progressInterval = setInterval(() => {
            this.getMDIDProgress();
        }, 1000);

        missingDeviceIdUsers.progressInterval = progressInterval;
        this.setState({ missingDeviceIdUsers });
    }

    clearMDIDInterval = () => {
        const { missingDeviceIdUsers } = this.state;
        if (missingDeviceIdUsers.progressInterval) {
            clearInterval(missingDeviceIdUsers.progressInterval);
        }
    }

    getMDIDProgress = async () => {
        console.log("getProgress")
        const { missingDeviceIdUsers } = this.state;
        const url = `${Config.getInstance.apiUrl}/api/users/get-mdid-progress`;
        const headers = {
            Authorization: Helpers.getSessionId(),
        };

        const response = await axios.get(url, { headers });

        if (response.data.success) {
            const progress = response.data.progress;
            missingDeviceIdUsers.progress = progress;

            console.log("progress", JSON.stringify(progress));
            this.setState({ missingDeviceIdUsers });
        }
    }

    renderMDIDProress = ()=>{
        const { missingDeviceIdUsers } = this.state;
        const progress = missingDeviceIdUsers.progress;

        // If progress is empty, return empty string
        if (Object.keys(progress).length === 0) {
            return "";
        }

        /*
        {
            totalUser: 0,
            currentUser: 0,
            totalSession: 0,
            currentSession: 0,
            currentAction: "",
        }
        */

        const str = `User (${progress.currentUser}/${progress.totalUser})
        Session (${progress.currentSession}/${progress.totalSession})
        Action: ${progress.currentAction}`;

        return str;
    }

    renderMissingDeviceIdUsersModal = () => {

        const styles = {
            h5: { display: "flex", alignItems: "center", justifyContent: "center", marginBottom: '10px' },
            h6: { display: "flex", alignItems: "center", marginBottom: '10px' },
        }

        return <Dialog
            open={this.state.missingDeviceIdUsers.showModal}
            onClose={this.onHideMissingDeviceIdUsersModal}
            fullWidth={true}
            maxWidth="lg"
        >
            <DialogTitle>
                Number of missing device_id users: {this.state.missingDeviceIdUsers.infectedAamount}
            </DialogTitle>
            <DialogContent dividers>
                <Grid container sm={12}>
                    <Grid item container sm={6} rowSpacing={2} style={styles.h5}>
                        <Grid sm={8}>
                            <Typography variant="h5">Get Data</Typography>
                        </Grid>
                        <Grid container style={styles.h6}>
                            <Grid item sm={2}>
                                <Typography variant="h6">Offset:</Typography>
                            </Grid>
                            <Grid item sm={6}>
                                <TextField
                                    inputProps={{ type: "number" }}
                                    value={this.state.missingDeviceIdUsers.offset}
                                    onChange={(e) => this.onChangeMDIDUsersValue(e, "offset")}
                                />
                            </Grid>
                        </Grid>

                        <Grid container style={styles.h6}>
                            <Grid item sm={2}>
                                <Typography variant="h6">Amount:</Typography>
                            </Grid>
                            <Grid item sm={6}>
                                <TextField
                                    inputProps={{ type: "number" }}
                                    value={this.state.missingDeviceIdUsers.amount}
                                    onChange={(e) => this.onChangeMDIDUsersValue(e, "amount")}
                                />
                            </Grid>
                        </Grid>

                        <Grid container style={styles.h6}>
                            <Button
                                disableElevation
                                variant="contained"
                                color="primary"
                                onClick={this.onGetListMDIDUsers}
                            >
                                Copy to clipboard
                            </Button>
                        </Grid>
                    </Grid>

                    <Grid item container sm={6} rowSpacing={2} style={styles.h5}>
                        <Grid item sm={12}>
                            <Typography variant="h5">Fix User Data</Typography>
                        </Grid>

                        <Grid item sm={12}>
                            <TextField
                                placeholder="Enter user ids separated by comma, ex: 1,2,3"
                                value={this.state.missingDeviceIdUsers.userToFix}
                                onChange={(e) => this.onChangeMDIDUsersValue(e, "userToFix")}
                                multiline
                                rows={5}
                                fullWidth
                            />
                        </Grid>
                        <Grid item sm={12}>
                            <Button
                                disableElevation
                                variant="contained"
                                color="primary"
                                onClick={this.onFixMDIDUsers}
                                style={{ float: "right" }}
                            >
                                <HealthAndSafetyIcon />
                                Fix them!
                            </Button>
                        </Grid>
                    </Grid>
                </Grid>
                <Grid sm={12}>
                    <Typography variant="h6">Progress</Typography>
                    <div>
                        {this.renderMDIDProress()}
                    </div>
                </Grid>
            </DialogContent>
        </Dialog>
    }

    onShowSendNotificationToAllUserModal = async ()=>{
        const { sendNotifyUserData } = this.state;
        sendNotifyUserData.showModal = true;
        this.setState({ sendNotifyUserData });
        
        await this.fetchSendNotifyUserData();
    }

    onHideSendNotificationToAllUserModal = ()=>{
        const { sendNotifyUserData } = this.state;
        sendNotifyUserData.showModal = false;
        this.setState({sendNotifyUserData});
    }

    onChangeSendNotifyUserContent = (event: any, key: string) => {
        console.log("onChangeSendNotifyUserContent", event.target.value);
        const { sendNotifyUserData } = this.state;
        sendNotifyUserData[key] = event.target.value;
        this.setState({ sendNotifyUserData });
    }

    onSendNotify = async () => {
        try {
            const { sendNotifyUserData } = this.state;
            const content = sendNotifyUserData.content;
            const title = sendNotifyUserData.title;
            
            if (sendNotifyUserData.sendByFcmList && sendNotifyUserData.fcmList.length === 0) {
                PopupMessage.error("Fcm list is empty!");
                return;
            }

            if (title.length === 0) {
                PopupMessage.error("Title is empty!");
                return;
            }

            if (content.length === 0) {
                PopupMessage.error("Content is empty!");
                return;
            }

            const url = `${Config.getInstance.apiUrl}/api/users/start_send_notify`;
            const headers = {
                Authorization: Helpers.getSessionId(),
            };

            this.startSendNotifyUserInterval();

            const response = await axios.post(url,
                { 
                    fcmList: sendNotifyUserData.sendByFcmList ? sendNotifyUserData.fcmList : '', 
                    title: sendNotifyUserData.title,
                    content, 
                    includeMuted: sendNotifyUserData.includeUsersMuted 
                },
                { headers }
            );

            // cleat interval
            this.clearSendNotifyUserInterval();

            //await this.fetchMDIDUsers();

            if (response.data.success) {
                PopupMessage.success("Send notify successfully!");
                sendNotifyUserData.progress.sendedUserCount = sendNotifyUserData.progress.totalUser;
            } else {
                PopupMessage.error(response.data.message + ': ' + response.data.interval);
            }

            this.setState({ sendNotifyUserData });
        } catch (e) {
            console.log('onSendNotify', e);
        }
    }

    startSendNotifyUserInterval = () => {
        const { sendNotifyUserData } = this.state;
        const progressInterval = setInterval(() => {
            this.getSendNotifyUserProgress();
        }, 1000);

        sendNotifyUserData.progressInterval = progressInterval;
        this.setState({ sendNotifyUserData });
    }

    clearSendNotifyUserInterval = () => {
        const { sendNotifyUserData } = this.state;
        if (sendNotifyUserData.progressInterval) {
            clearInterval(sendNotifyUserData.progressInterval);
        }
    }

    getSendNotifyUserProgress = async () => {
        console.log("getSendNotifyUserProgress")
        const { sendNotifyUserData } = this.state;
        const url = `${Config.getInstance.apiUrl}/api/users/get_send_notify_user_progress`;
        const headers = {
            Authorization: Helpers.getSessionId(),
        };

        const response = await axios.get(url, { headers });
        console.log(114455, response.data);

        if (response.data.success) {
            const progress = response.data.progress;
            sendNotifyUserData.progress = progress;
                        
            console.log("progress", JSON.stringify(progress));
            this.setState({ sendNotifyUserData });
        }
    }

    renderSendNotifyUserProress = ()=>{
        const { sendNotifyUserData } = this.state;
        const progress = sendNotifyUserData.progress;

        // If progress is empty, return empty string
        if (Object.keys(progress).length === 0) {
            return "not yet started!";
        }

        return progress.currentAction;
    }

    changeSendByFcmList = async (event) => {
        const flag = event.target.checked;
        const { sendNotifyUserData } = this.state;
        sendNotifyUserData.sendByFcmList = flag;
        this.setState({ sendNotifyUserData });
    }

    changeIncludeUserMuted = async (event) => {
        const flag = event.target.checked;
        const { sendNotifyUserData } = this.state;
        sendNotifyUserData.includeUsersMuted = flag;
        this.setState({ sendNotifyUserData });
    }

    renderSendNotifyUsesModal = () => {
        const styles = {
            h5: { display: "flex", alignItems: "center", justifyContent: "center", marginBottom: '10px' },
            h6: { display: "flex", alignItems: "center", marginBottom: '10px' },
        }

        return <Dialog
            open={this.state.sendNotifyUserData.showModal}
            onClose={this.onHideSendNotificationToAllUserModal}
            fullWidth={true}
            maxWidth="lg"
        >
            <DialogTitle>
                Send notification to all users
            </DialogTitle>
            <DialogContent dividers>
                <Grid container sm={12}>
                    <Grid item container sm={6} rowSpacing={2} style={styles.h5}>
                        <Grid sm={8}>
                            <Typography variant="h5">User Fcm Data</Typography>
                        </Grid>

                        <Grid container style={styles.h6}>
                            <Grid item sm={4}>
                                <Typography variant="h6">Title:</Typography>
                            </Grid>
                            <Grid item sm={6}>
                                <TextField
                                    inputProps={{ type: "string" }}
                                    value={this.state.sendNotifyUserData.title}
                                    onChange={(e) => this.onChangeSendNotifyUserContent(e, "title")}
                                />
                            </Grid>
                        </Grid>

                        <Grid container style={styles.h6}>
                            <Grid item sm={4}>
                                <Typography variant="h6">total:</Typography>
                            </Grid>
                            <Grid item sm={6}>
                                <TextField
                                    inputProps={{ type: "number" }}
                                    value={this.state.sendNotifyUserData.progress.totalUser}
                                    disabled={true}
                                />
                            </Grid>
                        </Grid>

                        <Grid container style={styles.h6}>
                            <Grid item sm={4}>
                                <Typography variant="h6">sended count:</Typography>
                            </Grid>
                            <Grid item sm={6}>
                                <TextField
                                    inputProps={{ type: "number" }}
                                    value={this.state.sendNotifyUserData.progress.sendedUserCount}
                                    disabled={true}
                                />
                            </Grid>
                        </Grid>
                    </Grid>

                    <Grid item container sm={6} rowSpacing={2} style={styles.h5}>
                        <Grid item sm={12}>
                            <Typography variant="h5">Content</Typography>
                        </Grid>

                        <Grid item sm={12}>
                            <TextField
                                placeholder="Enter content that send to users"
                                value={this.state.sendNotifyUserData.content}
                                onChange={(e) => this.onChangeSendNotifyUserContent(e, "content")}
                                multiline
                                rows={5}
                                fullWidth
                            />
                        </Grid>
                        <Grid item sm={12}>
                        
                            <label>Send by fcm list</label>
                            <Switch
                                checked={this.state.sendNotifyUserData.sendByFcmList}
                                onChange={this.changeSendByFcmList.bind(this)}
                                name="sendByFcmList"
                                inputProps={{ 'aria-label': 'controlled' }}
                            />


                            {/*
                            <label>Include muted users</label>
                            <Switch
                                checked={this.state.sendNotifyUserData.includeUsersMuted}
                                onChange={this.changeIncludeUserMuted.bind(this)}
                                name="includeUserMuted"
                                inputProps={{ 'aria-label': 'controlled' }}
                            />
                            */}
                            
                                    
                            <Button
                                disableElevation
                                variant="contained"
                                color="primary"
                                onClick={this.onSendNotify}
                                style={{ float: "right" }}
                            >
                                Send Notify
                            </Button>
                        </Grid>
                    </Grid>
                </Grid>
                
                {
                    this.state.sendNotifyUserData.sendByFcmList &&
                    <Grid container style={styles.h6}>
                        <Grid item sm={2}>
                            <Typography variant="h6">Send by Fcms:</Typography>
                        </Grid>
                            <TextField
                                placeholder="Enter content that send to users (fcm1;fcm2;...;fcmn;)"
                                value={this.state.sendNotifyUserData.fcmList}
                                onChange={(e) => this.onChangeSendNotifyUserContent(e, "fcmList")}
                                multiline
                                rows={5}
                                fullWidth
                            />
                    </Grid>
                }

                <Grid container style={styles.h6}>
                    <Grid item sm={2}>
                        <Typography variant="h6">Action:</Typography>
                    </Grid>
                    <Grid item sm={6}>
                        {this.renderSendNotifyUserProress()}
                    </Grid>
                </Grid>

            </DialogContent>
        </Dialog>
    }
    //#endregion
}
